__webpack_require__.p = "https://assets-01.periodica.press/076a624-19462687902/";